<template>
  <div class="xsjl">
    <div class="top_title wow fadeInUp" data-wow-delay="0.2s">
      <div class="top_text">
        <p>学术交流</p>
        <span>ACADEMIC EXCHANGE</span>
      </div>
      <div v-if="moreLink" class="more wow zoomIn" data-wow-delay="0.3s">
        <router-link :to="moreLink"><em>查看更多>></em></router-link>
      </div>
    </div>
    <ul>
      <li
        v-for="(item, index) in xsjlList"
        :key="item.ID"
        @mouseenter="hoverRoll(item)"
        class="wow fadeInLeft"
        :data-wow-delay="index / 5 + 's'"
      >
        <router-link
          :to="item.Url"
          :href="item.Url"
          @click.native="OpenLink(item.Url)"
        >
          <div class="textBox">
            <p class="title txt-cut1">{{ item.Title }}</p>
          </div>
          <div class="time">
            {{ setTimeformat(item.ShowTime6, "yyyy-mm-dd") }}
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "xsjl",
  props: {
    xsjlList: {
      // 图片列表
      type: Array,
      default: () => [],
    },
    moreLink: {
      type: String,
      default: "",
    },
    styles: {
      type: Object,
      default: () => {
        return {
          width: 1920,
          height: 500,
        };
      },
    },
  },
  data() {
    return {
      showItem: this.dataList ? this.dataList[0] : null,
    };
  },
  methods: {
    setTimeformat(_data, _format = "yyyy-mm-dd") {
      return _format
        .replace(/YYYY/i, _data.substr(0, 4))
        .replace(/MM/i, _data.substr(5, 2))
        .replace(/DD/i, _data.substr(8, 2));
    },
    hoverRoll(_data) {
      this.showItem = _data;
    },
  },
};
</script>
<style lang="less" scoped >
.xsjl {
  margin: 0;
  width: 590px;
  ul {
  width: 590px;
  height: auto;
  display: inline-block;
  vertical-align: top;
  padding: 0px 30px 0px 26px;
  box-sizing: border-box;
  li {
  width: 100%;
  height: 36px;
  margin-bottom: 15px;
  font-size: 0;
  border-bottom: dashed 1px #e4e4e4;
  box-sizing: border-box;
  &:last-child {
	margin-bottom: 0px;
	}
  &:hover{
    a{
      .textBox{
        color: #0376be;
      }
    }
  }
	a {
	display: flex;
	flex-wrap: nowrap;
	justify-content: space-between;
	.time {
		display: block;
		font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 1px;
    color: #333333;
		}
		.textBox {
		width: 350px;
		display: inline-block;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 2px;
    color: #333333;
		padding-left: 10px;
		box-sizing: border-box;
		position: relative;
		p{
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		&::before {
		content: "";
		width: 4px;
    height: 4px;
    background-color: #0376be;
		border-radius: 50%;
		display: block;
		position: absolute;
		top: 12px;
		left: 0px;
		}
	}
	}
  }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/xsjl.vue